import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router, UrlTree } from '@angular/router';
import { UserStore } from '@app/store/user.store';
import { interval, map, Observable, of, switchMap, takeWhile } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorGuard implements CanActivate {
  userStore = inject(UserStore);

  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return interval(100).pipe(
      switchMap(() => {
        const user = this.userStore.user();
        const loadUser = this.userStore.loadUser();

        if (!loadUser) {
          if (user && user.id !== -1 && user.admin) {
            return of(this.router.parseUrl('/admin'));
          } else if (user && user.id !== -1 && user.admin === false) {
            return of(this.router.parseUrl('/home'));
          } else {
            return of(true);
          }
        }
        return of(null);
      }),
      takeWhile((result) => result === null, true),
      map((result) => (result !== null ? result : false))
    );
  }
}
